// export const baseUrl = "https://umf0zo8c8l.execute-api.ap-northeast-1.amazonaws.com";
export const baseUrl = "https://73s71iqyx7.execute-api.ap-northeast-1.amazonaws.com";
// 自分のエンドポイントに置き換えてください